/* eslint-disable */

/** unique or primary key constraints on table "argo.role" */
export enum ArgoRoleConstraint {
  /** unique or primary key constraint on columns "context_id", "name_unique" */
  RoleNameEnforceUnique = 'role_name_enforce_unique',
  /** unique or primary key constraint on columns "role_id" */
  RolePkey = 'role_pkey'
}

/** select columns of table "argo.role" */
export enum ArgoRoleSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "argo_role_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.role" */
export enum ArgoRoleSelectColumnArgoRoleAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** select "argo_role_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.role" */
export enum ArgoRoleSelectColumnArgoRoleAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** update columns of table "argo.role" */
export enum ArgoRoleUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

